import { InfoDisplayField } from './InfoDisplayField';
import { useComparableMonthField } from './hooks/useComparableMonthField';

export const ComparableMonthField = () => {
    const { label, value } = useComparableMonthField();

    return <InfoDisplayField label={label} value={value} />;
};
